import React from 'react';
import loadingicon from '../assets/loadingIcon.png';

export default function LoaderScreen() {
	return (
		<div
			style={{
				background: '#282c34',
				position: 'fixed',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
				zIndex: 999999
			}}
		>
			<img src={loadingicon} alt="website logo" />
		</div>
	);
}
